import { render, staticRenderFns } from "./ConfirmDataAuth.vue?vue&type=template&id=16468ecd&lang=pug&"
import script from "./ConfirmDataAuth.vue?vue&type=script&lang=js&"
export * from "./ConfirmDataAuth.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmDataAuth.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports